module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_zoyi_m2.7c741044b8dfcd05b056a411f7a4a72e.png";